import BaseViz from './BaseViz'
import ScatterPlotChart from '../charts/ScatterPlotChart'
import HeatMapDataController from '../viz_behaviors/HeatMapDataController'
export default class HeatMapViz extends BaseViz {
  static defaultConfig = {
    sizeAttr: null,
    mode: 'grid',

    valueFormat: {
      type: [String, Array, Function, null],
      default: '[N]0,0.00',
    },
    unit: {
      type: [String, Boolean, null],
      default: false,
    },
    AxisHelper: {
      x: {
        trimThreshold: {
          nonEditable: true,
        },
        valueFormat: {
          nonEditable: true,
        },
        unit: {
          nonEditable: true,
        },
        showTickValues: {
          nonEditable: true,
        },
        scale: {
          value: 'band',
          options: ['band'],
          nonEditable: true,
          exposed: false,
        },
        domain: {
          nonEditable: true,
        },
        getExtent: function (data) {
          return data.map(d => d.x)
        },
        tickMatchData: {
          nonEditable: true,
          exposed: false,
        },
      },
      y: {
        trimThreshold: {
          nonEditable: true,
        },
        valueFormat: {
          nonEditable: true,
        },
        unit: {
          nonEditable: true,
        },
        scale: {
          value: 'band',
          options: ['band'],
          nonEditable: true,
        },
        domain: {
          nonEditable: true,
        },
        getExtent: function (data) {
          return data.map(d => d.y)
        },
      },
      zoom: {
        value: false,
        exposed: false,
        nonEditable: true,
      },
      scroll: {
        value: false,
        exposed: false,
        nonEditable: true,
      },
      showScrollbar: {
        type: Boolean,
        default: false,
        exposed: false,
      },
    },
    minSize: {
      exposed: false,
    },
    maxSize: {
      exposed: false,
    },
    showLabels: {
      type: Boolean,
      default: true,
      exposed: true,
    },
    ItemsHelper: {
      colorScale: {
        value: 'sequential3',
        options: ['sequential2', 'sequential3'],
      },
      colorKey: 'color',
    },

    TooltipBehavior: {
      getHtml: function (d) {
        return `
          <div class="important">${this.formatTooltipValue(d.color)}</div>
          <div>${this.valueWithUnit(d.x, 'x')} | ${this.valueWithUnit(d.y, 'y')}</div>`
      },
    },
    LegendBehavior: {
      interactive: {
        nonEditable: true,
        exposed: false,
      },
    },
  }
  static chartClass = ScatterPlotChart
  static dataControllerClass = HeatMapDataController
}
